import { ArrowLeft, ArrowRight, ExitIcon, RestartIcon } from 'components/Icons';
import { useThemeContext } from 'context/ThemeContext';
import { breakpoints } from 'theme/themes';

import styled from 'styled-components'
import { Link } from 'react-router-dom';

const ButtonWrap = styled.button`
    padding: 10px 1rem;
    color: ${props => props.theme.colors.primary};
    border: 1px solid ${props =>  props.borderColor };
    background-color: ${props => props.backgroundColor };
    border-radius: 1.5rem;
    font-size: 16px;
    cursor: pointer;
    
    font-family: ${props => props.theme.fonts.fontHeavy};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 300ms;

    @media ${breakpoints.small} {
      min-width: 120px;
      padding: 10px 1.5rem;
    }

    @media ${breakpoints.smallMedium} {
      min-width: 150px;
    }

    @media ${breakpoints.larger} {
      font-size: 18px;
    }
    &[disabled] {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:not([disabled]):hover {
      background-color: ${props => !props.noHover && props.theme.colors.primary};
      color: ${props => !props.noHover && "#fff"};
      border-color: ${props => !props.noHover && props.theme.colors.primary};

      .arrow-color {
        stroke: ${props => !props.noHover && "#fff"};
      }

      .restart-arrow {
        fill:  ${props => !props.noHover && "#fff"};
      }

      .exit-icon {
          fill:  ${props => !props.noHover && "#fff"};
      }
    }

    .button-home {
      display: flex;
      align-items: center;
    }
  `


export const ButtonContinue = ({noHover=false, disabled, onClick, borderColor='#fff', backgroundColor="#fff"}) => {
  const {theme} = useThemeContext()
  return (
    <ButtonWrap className='button button-continue' noHover={noHover} disabled={disabled} borderColor={borderColor} backgroundColor={backgroundColor} onClick={onClick}>
      <span style={{marginRight: '8px'}} className='button-text'>Continue</span>
      <ArrowRight color={theme.colors.primary}/>
    </ButtonWrap>
  )
}


export const ButtonGoBack = ({onClick}) => {
  const {theme} = useThemeContext()
  return (
    <ButtonWrap className='button button-go-back' borderColor={theme.colors.primary} onClick={onClick}>
      <ArrowLeft color={theme.colors.primary}/>
      <span style={{marginLeft: '8px'}} className='button-text'>Go back</span>
    </ButtonWrap>
  )
}

export const ButtonRestart = ({onClick}) => {
  const {theme} = useThemeContext()
  return (
    <ButtonWrap className='button button-restart' backgroundColor="#fff" borderColor="#fff" onClick={onClick}> <span style={{marginRight: '8px'}} className='button-text'>Restart scenario</span> <RestartIcon color={theme.colors.primary} /></ButtonWrap>
  )
}

export const ButtonHome = () => {
  const {theme} = useThemeContext()
  return (
    <Link to="/" className='button-home'><ButtonWrap className='button' backgroundColor="#fff" borderColor="#fff" > <ExitIcon color={theme.colors.primary} /> <span  style={{marginLeft: '8px'}} className='button-text'>Home</span></ButtonWrap></Link>
  )
}
